import React, { useEffect, useState } from "react";
import { Rating, CircularProgress } from "@mui/material";
import config from "@/config/config";
import { cn } from "@/lib/utils";

const GoogleReviewSummary = ({ className, text }) => {
  const [rating, setRating] = useState(null);
  const [reviewCount, setReviewCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReviewSummary = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${config.apiUrl}/api/review-summary`);
        const data = await response.json();

        if (response.ok && data.rating !== undefined) {
          setRating(data.rating);
          setReviewCount(data.user_ratings_total);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        } else {
          console.error(
            "Error fetching review summary:",
            data.error || "Unknown error"
          );
          setRating(null);
          setReviewCount(null);
        }
      } catch (error) {
        console.error("Error fetching review summary:", error);
        setRating(null);
        setReviewCount(null);
      }
    };

    fetchReviewSummary();
  }, []);

  return (
    <div>
      <div className={cn("hidden md:flex gap-2 items-center", className)}>
        <img className="md:size-12 size-10" src="/google-logo.svg" alt="" />

        <div className="max-w-sm my-5 rounded-lg p-2">
          <h2
            className={`text-base font-medium font-sans pb-2 text-${
              (text && text) || ""
            }`}
          >
            Google Bewertungen
          </h2>
          {loading ? (
            <p className={`text-${text ? text : "gray-500"}`}>Laden...</p>
          ) : rating !== null && reviewCount !== null ? (
            <>
              <div className="flex gap-2">
                <Rating value={rating} precision={0.1} readOnly />
                <p
                  className={`text-base font-medium text-${
                    text ? text : "gray-500"
                  }`}
                >
                  {rating?.toFixed(1)} von 5
                </p>
              </div>
              <p className={`text-${text ? text : "gray-500"}`}>
                ({reviewCount} Bewertungen)
              </p>
            </>
          ) : (
            <p className={` text-${text ? text : "gray-500"}`}>
              Keine Bewertungen <br /> verfügbar
            </p>
          )}
        </div>
      </div>
      {/* Mobile */}
      <div className="flex md:hidden py-3 flex-col items-center justify-center rounded-lg border bg-white ">
        <img className="size-5" src="/google-logo.svg" alt="" />

        <div className="max-w-sm  text-center rounded-lg px-1">
          <h2 className={`text-[0.5rem] text-gray-700 font-sans `}>
            Google Bewertungen
          </h2>
          {rating !== null && reviewCount !== null ? (
            <>
              <div className="flex items-center flex-col">
                <Rating value={rating} precision={0.1} size="small" readOnly />
                <p className={`text-sm font-medium text-gray-700`}>
                  {rating?.toFixed(1)} von 5
                </p>
              </div>
              <p className={`text-gray-700 text-[0.5rem]`}>
                ({reviewCount} Bewertungen)
              </p>
            </>
          ) : (
            <p className={`text-gray-700 text-[0.5rem]`}>
              Keine Bewertungen verfügbar
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoogleReviewSummary;
